import React from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';

const Footer = styled('div')`
  color: ${Theme.colors.lightText};
  font-size: 12px;
  padding-top: 20px;
`;

const TourFooter = ({ text }) => {
  return <Footer>{text}</Footer>;
};

export default TourFooter;
